"use client";
import { Send, Mail } from "lucide-react";
import { BRAND, MEDIA } from "../../lib/brand";

const quickLinks = [
  { label: "About", href: "#about" },
  { label: "Word Grid", href: "#featured" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#050505]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <a
              href={BRAND.axionTelegram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3"
              data-testid="footer-brand"
            >
              <div className="h-9 w-9 rounded-xl overflow-hidden border border-white/10 glow-soft">
                <img
                  src={MEDIA.axion_logo}
                  alt="Axion Bots"
                  className="h-full w-full object-cover"
                />
              </div>
              <span className="font-display text-xl font-medium">{BRAND.name}</span>
            </a>
            <p className="mt-5 text-sm text-neutral-400 max-w-sm leading-relaxed">
              A premium Telegram bot studio building automation, community and game
              bots trusted by thousands of groups.
            </p>

            <div className="mt-6 flex items-center gap-2">
              <a
                href={BRAND.ownerTelegram}
                target="_blank"
                rel="noreferrer"
                className="h-10 w-10 grid place-items-center rounded-lg border border-white/10 hover:border-[#00E5FF]/40 hover:text-[#00E5FF] transition-colors"
                data-testid="footer-social-telegram"
                aria-label="Telegram"
              >
                <Send className="h-4 w-4" />
              </a>
              <a
                href={BRAND.ownerEmail}
                target="_blank"
                rel="noreferrer"
                className="h-10 w-10 grid place-items-center rounded-lg border border-white/10 hover:border-[#00E5FF]/40 hover:text-[#00E5FF] transition-colors"
                data-testid="footer-social-email"
                aria-label="Direct message"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">Navigate</p>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-neutral-300 hover:text-white transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Telegram */}
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">Telegram</p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={BRAND.axionTelegram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-neutral-300 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="footer-link-axion"
                >
                  <Send className="h-3.5 w-3.5 text-[#7CCBF1]" />
                  {BRAND.axionHandle}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.flagshipBot.link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-neutral-300 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="footer-link-wordgrid"
                >
                  <Send className="h-3.5 w-3.5 text-[#7CCBF1]" />
                  {BRAND.flagshipBot.handle}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.ownerTelegram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-neutral-300 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="footer-link-owner"
                >
                  <Send className="h-3.5 w-3.5 text-[#7CCBF1]" />
                  {BRAND.ownerHandle}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.ownerEmail}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-neutral-300 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="footer-link-email"
                >
                  <Mail className="h-3.5 w-3.5 text-[#7CCBF1]" />
                  {BRAND.ownerEmailLabel}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <p className="text-xs text-neutral-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs text-neutral-500">
            Crafted for the Telegram community.
          </p>
        </div>
      </div>
    </footer>
  );
}
